/* eslint-disable prefer-arrow-callback */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
/* eslint-disable max-len */
/* eslint-disable eol-last */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable camelcase */
import React, { useState, useContext, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button, Stack } from '@mui/material';
import { AiFillShop, AiFillCreditCard, AiFillBank } from 'react-icons/ai';
import { FiLoader } from "react-icons/fi";
import { BsArrowLeft } from "react-icons/bs";
import toast, { Toaster } from 'react-hot-toast';
import { HostedForm } from 'react-acceptjs';
import SelectOptions from './components/SelectOptions';
import DatePicker from './components/DatePicker';
import axios from 'axios';
import full from './full_logo.png';
export const config = {
    Accept: 'application/json',
    headers: {
        // Authorization: `Bearer ${token}`,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
    },
};
const baseURL = process.env.REACT_APP_BASE_URL;

function CreateNewSub() {
    const { id, cid, sid } = useParams();
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [AddressLine, setAddressLine] = useState('');
    const [zipcode, setzipcode] = useState('');
    const [Province, setProvince] = useState('');
    const [city, setcity] = useState('');
    const [update, setUpdate] = useState(false);
    const [Email, setEmail] = useState('');
    const [PhoneNumber, setPhoneNumber] = useState('');
    const [planName, setPlanName] = useState('');
    const [Amount, setAmount] = useState('');
    const [FirstName, setFirstName] = useState('');
    const [LastName, setLastName] = useState('');
    const [trialPeriod, setTrialPeriod] = useState('');
    const [scheduleStartDate, setScheduleStartDate] = useState(new Date());
    const [scheduleEndDate, setScheduleEndDate] = useState(new Date());
    const [selectedInterval, setSelectedInterval] = useState('month');
    const [authorizeEnabled, setAuthorizeEnabled] = useState(false);
    const [helcminEnabled, setHelcimEnabled] = useState(false);
    const [loginId, setLoginId] = useState('');
    const [transactionKey, setTransactionKey] = useState('');
    const [AuthorizeModal, setAuthorizeModal] = useState(false);
    const [AuthorizeToken, setAuthorizeToken] = useState('');
    const [repetition, setRepetition] = useState('');
    const [currPage, setcurrPage] = useState(1);
    const [companyName, setCompanyName] = useState('');
    const [companyLogo, setCompanyLogo] = useState('');
    const [address, setAddress] = useState([]);
    const [loading1, setLoading1] = useState(false);

    const authData = {
        apiLoginID: loginId,
        clientKey: transactionKey,
    };
    const AuthorizeMenuOptions = [
        { label: 'Week', value: 'day' },
        { label: 'Month', value: 'month' },
    ];
    // const location = useLocation();

    // useEffect(() => {
    //     if (!sessionStorage.getItem('reloaded')) {
    //         sessionStorage.setItem('reloaded', 'true');
    //         window.location.reload();
    //     }
    //     return () => {
    //         sessionStorage.removeItem('reloaded');
    //     };
    // }, [location.pathname]);
    useEffect(() => {
        setLoading(true);
        handleGetAuthorizeAccount();
        handlegetCompanyName();
    }, []);
    const handlegetCompanyName = async () => {
        const response = await axios.get(`${baseURL}/company/unauthenticated-get-company/${id}`, {
            headers: {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
                Expires: '0',
            }
        })
        setCompanyName(response?.data?.data?.entity?.name);
        setCompanyLogo(response?.data?.data?.entity?.profile_photo_url);
        setAddress(response?.data?.data?.entity?.address_data);
        setLoading(false);
    }
    const handleGetAuthorizeAccount = async () => {
        const response = await axios.get(`${baseURL}/payment/authorize/get-authorize-account/${id}`);
        if (response?.data?.status === 'success') {
            setAuthorizeEnabled(response?.data?.data.entity?.is_active);
            setLoginId(response?.data?.data.entity?.api_login_id);
            setTransactionKey(response?.data?.data.entity?.public_client_key);
            // setLoading(false);
        }
        if (response?.data?.status === 'failure') {
            // setLoading(false);
            // toast.error(res.error);
        }
    };

    const handleAuthorizeSubmit = async (response) => {
        setLoading(true);
        toast('Process will take few mintutes! Please wait');
        const formData = {
            token: response?.opaqueData?.dataValue,
            first_name: FirstName,
            last_name: LastName,
            address: {
                street: AddressLine,
                zip: zipcode,
                state: Province,
                city: city,
                country: 'US',
            },
        };
        const res = await axios.put(`${baseURL}/subscription/authorize/update-payment-profile/${cid}/${id}`, formData, config);
        if (res?.data?.status === 'success') {
            toast.success(res?.data?.message);
            setUpdate(!update);
            setAddressLine('');
            setzipcode('');
            setProvince('');
            setcity('');
            setEmail('');
            setPlanName('');
            setAmount('');
            setFirstName('');
            setLastName('');
            setScheduleStartDate(new Date());
            setSelectedInterval('month');
            setLoading(false);
            setLoading1(true);
        }
        if (res?.data?.status === 'failure') {
            setLoading(false);
            toast.error(res?.data?.message);
            setTimeout(() => {
              window.reload();
            },[2000]);
        }
        setLoading(false);
    };

    if (loading) {
        return (
            <div className="w-full h-[100vh] items-center justify-between flex flex-col">
                <FiLoader size={50} className="animate-spin mt-[47vh]" />
                <div className='bg-[#fff] flex justify-center items-center relative text-[20px] pb-2 h-[1.5rem] w-full rounded-b-[8px] mb-[5vh]'>
                    {/* <a href="https://salescaptain.com/" target="_blank" className='underline text-blue-600 font-semibold' rel="noreferrer">
              Visit our website
            </a> */}

                    <span className="text-[#535355]"> Powered by</span>
                    <div
                        className='flex items-center ml-1 cursor-pointer'
                    >
                        <img src={localStorage.getItem('h_url') ?? 'https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2023-07-22/sales_captain_1690015901642.png'} className=" h-[18px]" alt="" />
                        <span
                            className="font-semibold ml-1"
                        >
                            {localStorage.getItem('h_name') ?? 'SalesCaptain'}
                        </span>
                    </div>
                </div>

            </div>
        );
    };
    if (loading1) {
        return (
            <div className="w-screen h-screen flex justify-center pt-[20%] sm:pt-[10%]">
                <div className="space-y-8 flex flex-col items-center">
                    <AiFillCreditCard className="text-green-600 text-3xl sm:text-5xl" />
                    <span className=" text-3xl sm:text-5xl text-green-600">Card Update Successful</span>
                    <span className="text-gray-400 px-14 text-xs sm:text-sm text-justify">Hurray !! We are delighted to inform you that we have updated your card Details</span>
                </div>
            </div>
        )
    };
    const isValid = !(zipcode?.length > 0 && Province.length > 0 && city?.length > 0 && zipcode?.length > 0 && FirstName.length > 0 && LastName.length > 0);

    return (
        <div className="h-screen w-screen flex flex-col items-center justify-center  overflow-x-hidden overflow-y-auto">
            <div className="flex gap-3 items-center  text-[#1a1a1ab3] medium text-[15px]">
                {companyLogo && (
                    <span className="text-[#1a1a1ab3] medium text-[15px] bg-white  
            p-1 w-[60px] h-[60px] rounded-md object-fill"
                    >
                        {' '}
                        <img className="w-full h-full" src={companyLogo} alt="" />

                    </span>
                )}
                <div className="flex flex-col gap-1">
                    <span className="text-[#3975cb]  medium text-[18px] tracking-wide">{companyName}</span>
                    <span className="regular text-[10px] tracking-wide">
                        {address?.street_address}
                        {' '}
                        {address?.apartment_or_suite}
                        {' '}
                        {address?.city}
                        {' '}
                        {address?.zip}
                    </span>
                </div>
            </div>

            <div className="space-y-2 text-gray-500 shadow-xl flex flex-col rounded-[25px] border-[1px] border-[#E2E8F0] p-3 px-7 w-[500px] mt-3">
                <div className="flex-row  item-center justify-center ">

                    <div className="p-[0.2rem] item-center justify-center h-fit flex flex-col space-y-2 space-x-2">
                        <div className="  flex item-center justify-center  text-left ">
                            <div className="w-full flex  flex-col items-center justify-center mt-1 p-3 sm:p-1">
                                <div className="flex sm:flex-row flex-col w-[100%]">
                                    <div item className="flex-col  w-full py-2">
                                        <div className="text-[11px] pb-1.5 pl-1 text-slate-700">First Name</div>
                                        <textarea
                                            name="FirstnAME"
                                            value={FirstName}
                                            onChange={(e) => setFirstName(e.target.value)}
                                            className="hover:!ring-2 w-[100%] shadow-sm shadow-gray-200 hover:!border-[1px] border !bg-white max-h-[120px] min-h-[40px] h-[40px] resize-none
            rounded-[8px] outline-none  p-2 disabled:bg-gray-300 text-sm placeholder:text-sm
            hover:!ring-blue-200  hover:!border-blue-500 focus:!ring-4 focus:!ring-blue-200 focus:!border-blue-500"
                                        />
                                    </div>
                                    <div item className="flex-col sm:pl-2 py-2 w-full">
                                        <div className="text-[11px] pb-1.5 pl-1 text-slate-700">Last Name</div>
                                        <textarea
                                            name="code"
                                            value={LastName}
                                            onChange={(e) => setLastName(e.target.value)}
                                            className="hover:!ring-2 w-[100%] shadow-sm shadow-gray-200 hover:!border-[1px] border !bg-white max-h-[120px] min-h-[40px] h-[40px] resize-none
            rounded-[8px] outline-none  p-2 disabled:bg-gray-300 text-sm placeholder:text-sm
            hover:!ring-blue-200  hover:!border-blue-500 focus:!ring-4 focus:!ring-blue-200 focus:!border-blue-500"
                                        />
                                    </div>
                                </div>
                                <div className="flex sm:flex-row flex-col w-[100%]">
                                    <div item className="flex-col  w-full py-2">
                                        <div className="text-[11px] pb-1.5 pl-1 text-slate-700">Address Line</div>
                                        <textarea
                                            name="AddressLine"
                                            value={AddressLine}
                                            onChange={(e) => setAddressLine(e.target.value)}
                                            className="hover:!ring-2 w-[100%] shadow-sm shadow-gray-200 hover:!border-[1px] border !bg-white max-h-[120px] min-h-[40px] h-[40px] resize-none
            rounded-[8px] outline-none  p-2 disabled:bg-gray-300 text-sm placeholder:text-sm
            hover:!ring-blue-200  hover:!border-blue-500 focus:!ring-4 focus:!ring-blue-200 focus:!border-blue-500"
                                        />
                                    </div>
                                    <div item className="flex-col sm:pl-2 py-2 w-full">
                                        <div className="text-[11px] pb-1.5 pl-1 text-slate-700">City</div>
                                        <textarea
                                            name="city"
                                            value={city}
                                            onChange={(e) => setcity(e.target.value)}
                                            className="hover:!ring-2 w-[100%] shadow-sm shadow-gray-200 hover:!border-[1px] border !bg-white max-h-[120px] min-h-[40px] h-[40px] resize-none
            rounded-[8px] outline-none  p-2 disabled:bg-gray-300 text-sm placeholder:text-sm
            hover:!ring-blue-200  hover:!border-blue-500 focus:!ring-4 focus:!ring-blue-200 focus:!border-blue-500"
                                        />
                                    </div>
                                </div>
                                <div className="flex sm:flex-row flex-col w-[100%]">
                                    <div item className="flex-col  w-full py-2">
                                        <div className="text-[11px] pb-1.5 pl-1 text-slate-700">State</div>
                                        <textarea
                                            name="Province"
                                            value={Province}
                                            onChange={(e) => setProvince(e.target.value)}
                                            className="hover:!ring-2 w-[100%] shadow-sm shadow-gray-200 hover:!border-[1px] border !bg-white max-h-[120px] min-h-[40px] h-[40px] resize-none
            rounded-[8px] outline-none  p-2 disabled:bg-gray-300 text-sm placeholder:text-sm
            hover:!ring-blue-200  hover:!border-blue-500 focus:!ring-4 focus:!ring-blue-200 focus:!border-blue-500"
                                        />
                                    </div>
                                    <div item className="flex-col sm:pl-2 py-2 w-full">
                                        <div className="text-[11px] pb-1.5 pl-1 text-slate-700">Postal code</div>
                                        <textarea
                                            name="code"
                                            value={zipcode}
                                            onChange={(e) => setzipcode(e.target.value)}
                                            onKeyPress={(e) => {
                                                const validKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
                                                if (!validKeys.includes(e.key)) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            className="hover:!ring-2 w-[100%] shadow-sm shadow-gray-200 hover:!border-[1px] border !bg-white max-h-[120px] min-h-[40px] h-[40px] resize-none
            rounded-[8px] outline-none  p-2 disabled:bg-gray-300 text-sm placeholder:text-sm
            hover:!ring-blue-200  hover:!border-blue-500 focus:!ring-4 focus:!ring-blue-200 focus:!border-blue-500"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="  flex item-center justify-center  text-left ">
                            <div className="w-full flex  flex-col items-center justify-center  ">
                                <div className="flex flex-col  w-[100%]">
                                    <div className="flex items-center justify-center mt-4  pb-[20px]">
                                        {isValid === true && (
                                            <button type="submit" disabled={isValid} className="flex items-center w-[250px] justify-center  disabled:!bg-gray-400   !bg-blue-500 mt-2  font-semibold shadow-md shadow-gray-200 focus:ring-4 gap-1  border border-gray-300 text-white regular text-[14px] rounded-[12px] focus:!ring-blue-200 focus:!border-blue-500  focus:border-[1px] p-2.5">Update Card details</button>
                                        )}
                                        {isValid === false && (
                                            <HostedForm
                                                authData={authData}
                                                onSubmit={handleAuthorizeSubmit}
                                                environment="PRODUCTION"
                                                buttonText="Update Card details"
                                                formButtonText="Save"
                                                formHeaderText="Enter Card Details"
                                                buttonClassName="flex items-center  w-[250px] justify-center  disabled:!bg-gray-400   !bg-blue-500 mt-2  font-semibold shadow-md shadow-gray-200 focus:ring-4 gap-1  border border-gray-300 text-white regular text-[14px] rounded-[12px] focus:!ring-blue-200 focus:!border-blue-500  focus:border-[1px] p-2.5"
                                                onError={(error) => console.error('Error:', error)}
                                            />
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className='flex justify-center gap-2 items-center mt-5'>
                <span className="text-gray-400 regular self-center mt-1 text-[10px]">Powered by </span>
                <img className=" h-[14px]" src={full} alt="" />
            </div>
            <Toaster
                position="top-center"
                reverseOrder={false}
            />
        </div>
    );
}

export default CreateNewSub;